<ll-titulo>{{ titulo ? titulo : (tituloKey | t) }}</ll-titulo>
<ll-tabs><corregir-ensayos-tabs-profesor [typePlatform]="typePlatform"></corregir-ensayos-tabs-profesor></ll-tabs>

<corregir-ensayos-tabs-contenido-profesor
    [typePlatform]="typePlatform"
    [evaluacionId]="evaluacionId"
    [perfil]="perfil"
></corregir-ensayos-tabs-contenido-profesor>
